import routes from "../../config/routes";
function getPublicRoutes() {
    const result = [];
    let remainingRoutes = [...routes];
    while (remainingRoutes.length > 0) {
        const route = remainingRoutes.shift();
        if (route === undefined) {
            continue;
        }
        if (Array.isArray(route.routes)) {
            remainingRoutes = remainingRoutes.concat([...route.routes]);
        }
        if (route.public && route.path) {
            result.push(route.path);
        }
    }
    return result;
}
// eslint-disable-next-line import/prefer-default-export
export const publicRoutes = getPublicRoutes();
